/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { ProgressTileViewModel } from 'src/types/view-models/progress-tile.view.model';
import ProgressService from '../../services/progress.service';

import ProgressBar from 'src/bw/progress-bar/ProgressBar';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import styles from './ProgressTile.module.scss';

export default class ProgressTile extends Component<ProgressTileViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className={styles.progressTileContainer} style={{ width: this.props.width }}>
                <div className={styles.topRow}>
                    <div>
                        <Typography variant={TypographyVariants.BODY}>
                            {ProgressTileViewModel.getHeadline(this.props)}
                        </Typography>
                    </div>
                    <div>
                        <Typography variant={TypographyVariants.CAPTION}>
                            {ProgressService.getBarWidth(this.props.progressBar)} complete
                        </Typography>
                    </div>
                </div>
                <div className={styles.bottomRow}>
                    <ProgressBar {...this.props.progressBar} />
                </div>
            </div>
        );
    }
}
